import React, {CSSProperties, ReactNode, Ref} from 'react';
import {FormattedMessage} from 'react-intl';
import {FloatingPortal} from '@floating-ui/react';
import styled from 'styled-components';
import {useScrollLogic} from './logic';
import {NoDropdownMenuItems} from "../DropdownMenuItems";
import messages from "../messages";
import {greyColorTokens} from "../../../tokens/color";
import {borderRadiusTokens} from "../../../tokens/borderRadius";
import {GetMenuPropsOptions} from "downshift";

interface DropdownMenuProps {
    children: ReactNode;
    noItems: boolean;
    getMenuProps: (props?: GetMenuPropsOptions, otherOptions?: {suppressRefError?: boolean}) => any;
    onScrollToBottom?: () => any;
    noItemsMessage: ReactNode;
    width?: number;
    highlightedIndex: number | null;
    setHighlightedIndex: (args: any) => any;
    itemsCount: number;
    floatingRef: Ref<HTMLDivElement>;
    floatingStyles: CSSProperties;
}

export function DropdownMenu(props: DropdownMenuProps) {
    const {
        children,
        noItems,
        getMenuProps,
        onScrollToBottom,
        highlightedIndex,
        noItemsMessage,
        setHighlightedIndex,
        itemsCount,
        width,
        floatingRef,
        floatingStyles,
    } = props;

    const {onScroll} = useScrollLogic(highlightedIndex, setHighlightedIndex, itemsCount, onScrollToBottom);

    const menuProps = getMenuProps({onScroll}, {suppressRefError: true});

    return (
        <FloatingPortal>
            <div
                ref={floatingRef}
                style={{...floatingStyles, zIndex: 999, width: width ? `${width}px` : undefined}}
            >
                <DropdownMenuWrapper {...menuProps}>
                    {noItems ? (
                        <NoDropdownMenuItems>
                            {noItemsMessage ? noItemsMessage : (
                                <FormattedMessage {...messages.noItems}/>
                            )}
                        </NoDropdownMenuItems>
                    ) : null}
                    {children}
                </DropdownMenuWrapper>
            </div>
        </FloatingPortal>
    );
}

const DropdownMenuWrapper = styled.div`
    background-color: ${greyColorTokens.white000()};
    border: 1px solid ${greyColorTokens.grey800()};
    box-shadow: 0px 1px 3px rgba(83, 83, 83, 0.2);
    border-radius: ${borderRadiusTokens.small};
    padding: 0;
    max-height: 292px;
    overflow: auto;
`;
